var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 11.996H9.924L9.06 14H7.5L11.364 5.456H12.624L16.5 14H14.952L14.1 11.996ZM13.584 10.796L12.012 7.136L10.44 10.796H13.584Z",
    fill: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppercase);
export default __webpack_public_path__ + "static/media/uppercase.de7cf0a5eb38afd42a95fba2ba879e65.svg";
export { ForwardRef as ReactComponent };